import script from "./DataIngestionTodayAlertsSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionTodayAlertsSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionTodayAlertsSkeleton.vue?vue&type=style&index=0&id=5ecf1221&scoped=true&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ecf1221"]])

export default __exports__